export function joinNonEmpty(items: (string | null | undefined)[], separator = "\n"): string {
  return items.filter(Boolean).join(separator);
}

export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function removeTruckMention(value: string | null, number: string | null | undefined): string {
  if (!value || !number) {
    return value || "";
  }

  return value
    .replace(new RegExp(`[#№] ?${escapeRegExp(number)} ?`, "g"), "")
    .replace(/ truck /gi, " ")
    .trim();
}

export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
